import type { PriceItem } from "$lib/types/spotPriser";
import { scaleLinear, extent } from "d3";

export const getPriceToPx = (prices: PriceItem[], px: number, notZeroMin?: boolean) => {
  const setChartDomain = (extentDomain: [number, number]) => {
    const [min, max] = extentDomain;
    const domainStart = notZeroMin ? min : Math.min(0, min);
    return [domainStart, max];
  };

  const domainPrices = extent(prices.map((x) => x.pris)) as [number, number];

  return !prices
    ? null
    : scaleLinear()
      .domain(setChartDomain(domainPrices)) // unit: øre/kWh
      .range([0, px]); // unit: pixels
};

export const getPriceToSvg = (prices: PriceItem[], px: number, notZeroMin = false) => {
  const setChartDomain = (extentDomain: [number, number]) => {
    const [min, max] = extentDomain;
    const domainStart = notZeroMin ? min : Math.min(0, min);
    const domainEnd = max;
    return [domainEnd, domainStart];
  };

  const domainPrices = extent(prices.map((x) => x.pris)) as [number, number];

  return !prices
    ? null
    : scaleLinear()
      .domain(setChartDomain(domainPrices)) // unit: øre/kWh
      .range([0, px]); // unit: pixels
};

export default getPriceToPx;
